/**
 * Feature Data for Welcome Page
 *
 * Feature: 011-registration-welcome
 *
 * Defines the 5 key BOSI features displayed on the welcome page.
 * Each feature includes an icon, title, and 1-2 sentence description.
 */

import React from 'react';

export interface Feature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

export const featureData: Feature[] = [
  {
    icon: (
      <svg
        className="w-8 h-8 text-primary-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
        />
      </svg>
    ),
    title: 'Daily Check-Ins',
    description:
      'Track your mood, energy, symptoms, and sleep quality in under 2 minutes each day. Build a personalized wellness journal that identifies patterns over time.',
  },
  {
    icon: (
      <svg
        className="w-8 h-8 text-primary-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
        />
      </svg>
    ),
    title: 'Body State Identification',
    description:
      'Understand whether you\'re in recovery, balanced, high energy, or experiencing hormonal shifts. Receive tailored guidance for each state.',
  },
  {
    icon: (
      <svg
        className="w-8 h-8 text-primary-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M7 12l3-3 3 3 4-4M8 21l4-4 4 4M3 4h18M4 4h16v12a1 1 0 01-1 1H5a1 1 0 01-1-1V4z"
        />
      </svg>
    ),
    title: 'Progress Tracking',
    description:
      'Visualize your wellness journey with interactive charts and timelines. Discover correlations between sleep, mood, and symptoms.',
  },
];
